'use client';

import { useContext } from 'react';

import { DistanceContext, DistanceState } from '@/providers/distance-provider';

export const useDistanceContext = (): DistanceState => {
  const context = useContext(DistanceContext);

  if (!context) {
    throw new Error('useDistanceContext must be used within a DistanceProvider');
  }

  return context;
};
